import React, { Component } from "react";
import { Tab, Tabs } from 'react-bootstrap';
import AssessmentListTable from "../../components/v2/AssessmentListTable";
import SetupListTable from "../../components/v2/SetupListTable";
import Search from '../../components/v2/Search';

import { DEFAULT_TAB, ASSESSMENT_PERIOD } from "../../fastConstants";

const FAST_URL = process.env.REACT_APP_DS_API_URL
const LOG_URL = false
const LOG_RESPONSE = false

class V1Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: DEFAULT_TAB,
            assessmentDepartmentFilter: '',
            assessmentSchoolFilter: 'ALL',
            setupDepartmentFilter: '',
            setupSchoolFilter: 'ALL',
            setupDepartments: [],
            submittedPrograms: [],
            departmentAssessments: [],
        }
        this.filterDepartmentAssessments = this.filterDepartmentAssessments.bind(this)
        this.filterDepartmentSetups = this.filterDepartmentSetups.bind(this)
    }
    fetchDepartmentSetups() {
        const url = FAST_URL + "/setup?reviewYear=" + ASSESSMENT_PERIOD;

        if (LOG_URL) console.log(url)

        let setupsList = []
        fetch(url).then(response => {
            return response.json();
        }).then(data => {
            if (LOG_RESPONSE) console.log(data)

            setupsList = data.map((report) => {
              return report
            });
            setupsList.sort( (r1, r2) => {
                if (r1.name > r2.name) return 1;
                if (r1.name < r2.name) return -1;
                return 0;
            })
            this.setState({ setupDepartments: setupsList})
        })
        .catch(err => console.log(err));
    }
    fetchDepartmentAssessments() {
        const url = FAST_URL + "/assessments?compact=true&reviewYear=" + ASSESSMENT_PERIOD;
        console.log('TODO: remove the compact flag and fully implement the compact version of the response')
        if (LOG_URL) console.log(url)
        
        fetch(url)
        .then(response => {
            return response.json();
        })
        .then(data => {
            if (LOG_RESPONSE) console.log(data)
            
            data.sort( (r1, r2) => {
                if (r1.name > r2.name) return 1;
                if (r1.name < r2.name) return -1;
                return 0;
            })
            this.setState({ departmentAssessments: data})
        })
        .catch(err => console.log(err))
    }
    componentDidMount() {
        this.fetchDepartmentAssessments()
        this.fetchDepartmentSetups()
    }

    onAssessmentDepartmentFilterChanged = event => {
        this.setState({ assessmentDepartmentFilter: event.target.value })
    }
    onSetupDepartmentFilterChanged = event => {
        this.setState({ setupDepartmentFilter: event.target.value })
    }

    onAssessmentSchoolFilterChanged = event => {
        this.setState({ assessmentSchoolFilter: event.target.value })
    }
    onSetupSchoolFilterChanged = event => {
        this.setState({ setupSchoolFilter: event.target.value })
    }
    
    filterDepartmentAssessments() {
        if (this.state.assessmentDepartmentFilter === '') {
            return this.state.departmentAssessments.filter((node) => {
                const upperSchool = node.school.toUpperCase()
                return this.state.assessmentSchoolFilter === 'ALL' || upperSchool === this.state.assessmentSchoolFilter
            })
        }
        return this.state.departmentAssessments.filter( (node) => {
            const filter = this.state.assessmentDepartmentFilter.toUpperCase()
            const upperSchool = node.school.toUpperCase()
            const upperDepartmentName = node.name.toUpperCase()
            return upperDepartmentName.includes(filter) && (upperSchool === this.state.assessmentSchoolFilter || this.state.assessmentSchoolFilter === 'ALL')
        })
    }
    filterDepartmentSetups() {
        if (this.state.setupDepartmentFilter === '') {
            return this.state.setupDepartments.filter((node) => {
                const upperSchool = node.school.toUpperCase()
                return this.state.setupSchoolFilter === 'ALL' || upperSchool === this.state.setupSchoolFilter
            })
        }
        return this.state.setupDepartments.filter( (node) => {
            const filter = this.state.setupDepartmentFilter.toUpperCase()
            const upperSchool = node.school.toUpperCase()
            const upperDepartmentName = node.name.toUpperCase()
            return upperDepartmentName.includes(filter) && (upperSchool === this.state.setupSchoolFilter || this.state.setupSchoolFilter === 'ALL')
        })
    }
    render() {
        const filteredDepartments = this.filterDepartmentAssessments()
        const filteredSetups = this.filterDepartmentSetups()
        
        return (
            <React.Fragment>
                <div className="pt-5">
                    <div>
                        <p className="fs-6 text-muted" style={{"textIndent":"50px"}}>
                            Use the Setup tab on the right to complete initial tasks before 
                            beginning the assessment cycyle. After completing the setup for
                            your degrees, certificates, and/or gen ed areas, use the Assessments
                            tab on the left to begin the assessment cycle. Please review background
                            information about the assessment process before you begin. 
                            &nbsp;<a href="https://rise.articulate.com/share/_xKJgBYqG_3uugKY8h92SOJYGICSk7v8" target="_blank" rel="noreferrer">View</a>
                        </p>
                    </div>
                    <Tabs
                        activeKey={this.state.activeTab}
                        onSelect={(k) => this.setState({activeTab: k})}
                        id="fast-tabs"
                        className="mb-3"
                        fill
                        >
                        <Tab eventKey="assessment" title="Assessment">
                            <div className="col cp-card-holder">
                                <div className="card mb-4 rounded-3 shadow-sm">
                                    <div className="card-header py-3">
                                        <h4 className="my-0 fw-normal">Department Assessments</h4>
                                    </div>
                                    <div className="card-body">
                                        <Search
                                            name={'assessmentsFilter'}
                                            onFilterChanged={this.onAssessmentDepartmentFilterChanged}
                                            onSchoolChanged={this.onAssessmentSchoolFilterChanged}
                                            />
                                        <br/>
                                        <AssessmentListTable
                                            departments={filteredDepartments}
                                            />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey="setup" title="Setup">
                            <div className="col cp-card-holder">
                                <div className="card mb-4 rounded-3 shadow-sm">
                                    <div className="card-header py-3">
                                        <h4 className="my-0 fw-normal">Department Setups</h4>
                                    </div>
                                    <div className="card-body">
                                        <Search
                                            name={'setupsFilter'}
                                            onFilterChanged={this.onSetupDepartmentFilterChanged}
                                            onSchoolChanged={this.onSetupSchoolFilterChanged}
                                            />
                                        <SetupListTable
                                            departments={filteredSetups}
                                            />
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </React.Fragment>
        )
    }
}

export default V1Home;